import Slider from '@mui/material/Slider';
import { styled } from '@mui/system';

export const CustomSlider = styled(Slider)(({ theme }) => ({
  '&.MuiSlider-root': {
    color: theme.palette.primary.main,
    height: 8,
    '&.Mui-disabled': {
      color: theme.palette.primary.main
    }
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    top: '73%',
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: 'inherit'
    },
    '&.Mui-disabled': {
      height: 24,
      width: 24,
      backgroundColor: '#fff',
      border: '2px solid currentColor',
      marginTop: -8
    }
  },
  '& .MuiSlider-valueLabel': {
    left: 'calc(-50% + 4px)'
  },
  '& .MuiSlider-track': {
    height: 8,
    borderRadius: 4,
    border: 'none'
  },
  '& .MuiSlider-rail': {
    height: 8,
    borderRadius: 4,
    opacity: 1
  }
}));
